<template>
  <div>
    <div>
      <el-button @click="uploadImg">上传图片</el-button>
      <el-row :gutter="40" style="margin-top: 1vh">
        <el-col :span="6" v-for="item in data" :key="item.iconClass">
          <div class="box" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
            <el-col :span="12">
              <i :class="['icon', item.iconClass]"></i>
            </el-col>
            <el-col :span="12" class="info">
              <span class="text">{{ item.info }}</span>

              <span class="num">
                <NumberGrow :value="item.num"></NumberGrow>
              </span>
            </el-col>
          </div>
        </el-col>
      </el-row>
    </div>
    <div id="myChart" :style="{
        width: '100%',
        height: '65vh',
        marginTop: '30px',
        background: '#fff',
        borderRadius: '10px',
      }"></div>
    <el-dialog title="图片" :visible.sync="upImg" :close-on-click-modal="false" width="88%" class="global-dialog-position"
      style="margin-top: -5vh">
      <imgUpload ref="imgUpload" />
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForms">确 定</el-button>
        <!-- <el-button @click="getout">取 消</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import NumberGrow from "../components/numScoll.vue";
  import imgUpload from "../components/uploadImg.vue";
  export default {
    components: {
      NumberGrow,
      imgUpload,
    },
    data() {
      return {
        upImg: false,
        data: [{
            iconClass: "el-icon-user",
            info: "用户数量",
            num: 33290
          },
          {
            iconClass: "el-icon-shopping-cart-2",
            info: "已售车位",
            num: 24292
          },
          {
            iconClass: "el-icon-phone-outline",
            info: "潜在用户",
            num: 900
          },
          {
            iconClass: "el-icon-goods",
            info: "已收藏车位",
            num: 998
          },
        ],
      };
    },
    mounted() {
      this.drawLine();
    },
    methods: {
      // 确定
      submitForms() {
        console.log(this.$refs.imgUpload.faData);
      },
      // 图片上传
      uploadImg() {
        this.upImg = true;
      },
      drawLine() {
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById("myChart"));
        // 绘制图表
        myChart.setOption({
          tooltip: {
            trigger: "axis",
          },
          legend: {
            data: ["销量", "锁定", "用户数量"],
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
          },
          toolbox: {
            feature: {
              saveAsImage: {},
            },
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: ["1月", "2月", "3月", "4月", "5月", "6月", "7月"],
          },
          yAxis: {
            type: "value",
          },
          series: [{
              name: "销量",
              type: "line",
              smooth: true,
              data: [120, 532, 301, 434, 290, 230, 210],
            },
            {
              name: "锁定",
              type: "line",
              smooth: true,
              data: [220, 382, 191, 234, 290, 330, 310],
            },
            {
              name: "用户数量",
              type: "line",
              smooth: true,
              data: [150, 332, 201, 154, 190, 430, 410],
            },
          ],
        });
        // 定义一个变量用于存储定时器的ID
        var debounceTimer = null;
        myChart.getZr().on("mousemove", function(params) {
          var pointInPixel = [params.offsetX, params.offsetY];
          if (myChart.containPixel("grid", pointInPixel)) {
            // 清除之前的定时器
            clearTimeout(debounceTimer);

            // 设置一个新的定时器，1秒后执行逻辑
            debounceTimer = setTimeout(function() {
              /*此处添加具体执行代码*/
              var pointInGrid = myChart.convertFromPixel({
                  seriesIndex: 0
                },
                pointInPixel
              );
              //X轴序号
              var xIndex = pointInGrid[0];
              //获取当前图表的option
              var op = myChart.getOption();
              //获得图表中我们想要的数据
              var month = op.xAxis[0].data[xIndex];
              var value = op.series[0].data[xIndex];
              console.log(month);
              console.log(value);
            }, 500);
          }
        });
        myChart.on("click", function(params) {
          // 判断点击的是折线图系列中的一条线
          if (params.componentType === "series" && params.seriesType === "line") {
            console.log("点击了线图系列：" + params.name);
            console.log("点击的x轴索引：" + params.dataIndex);
            console.log("点击的值：" + params.value);
            // 在这里编写点击事件的处理逻辑
          }
        });
      },
      handleMouseEnter(event) {
        event.target.style.transform = "translateY(-5px)";
        event.target.style.cursor = "pointer";
      },
      handleMouseLeave(event) {
        event.target.style.transform = "translateY(0)";
        event.target.style.cursor = "default";
      },
    },
  };
</script>

<style scoped>
  .box {
    height: 100px;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.3s ease, background-color 0.3s ease;
  }

  .box:hover {
    background-color: #eeeeee;
  }

  .icon {
    font-size: 40px;
    vertical-align: middle;
  }

  .el-icon-user {
    color: #9a9a9a;
  }

  .el-icon-shopping-cart-2 {
    color: #6495ed;
  }

  .el-icon-phone-outline {
    color: #7cfc00;
  }

  .el-icon-goods {
    color: #ffa500;
  }

  .info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding-left: 10px;
  }

  .text {
    font-size: 16px;
  }

  .num {
    font-size: 20px;
    font-weight: bold;
  }
</style>


// WEBPACK FOOTER //
// src/views/homepage.vue